<template>
  <div class="imgModal" @click="close" v-show="value">
    <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
        <!-- <div class="modal-header">
            <slot name="header">Header</slot>
        </div> -->
        <div class="modal-body">
            <slot name="body">
                <img :src="selectedUrl"/>
            </slot>
        </div>
        <!-- <div class="modal-footer">
            <slot name="footer">Footer</slot>
        </div> -->
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'lgImageModal',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    selectedUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    close () {
      this.$emit('input', !this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lgImageModal.vue